// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../images/misc/loading.gif");
var ___HTML_LOADER_IMPORT_1___ = require("../images/misc/loading_reversed.gif");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var code = "<div> <img class=\"rip-loading-icon\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" ng-show=\"pendingRequest()\"/> <img class=\"rip-loading-icon\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\" ng-show=\"pendingRequestCompletion()\"/> </div> ";
// Exports
module.exports = code;